import { useState } from "react";
import { usd, fecha } from "./util";
import { corto, colorEstado, diasTxt, sumaD, MESES } from "./graf";

const W = 1000, H = 150, BASE = 118, TOP = 26;

const agrupar = (venc) => {
  if (venc.length <= 14) return venc;
  const sem = {};
  venc.forEach((v) => { const k = sumaD(v.fecha, -((new Date(`${v.fecha}T00:00:00`).getDay() + 6) % 7)); const g = sem[k] || (sem[k] = { ...v, fecha: k, monto: 0, facturas: 0, semana: true }); g.monto += v.monto; g.facturas += v.facturas || 1; g.dias = Math.max(g.dias, v.dias); });
  return Object.values(sem);
};

export const LineaTiempo = ({ d }) => {
  const [tip, setTip] = useState(null);
  const hoy = d.fecha_corte;
  const venc = (d.vencimientos || []).filter((v) => v.fecha);
  if (!venc.length) return null;
  const pts = agrupar(venc).sort((a, b) => a.fecha.localeCompare(b.fecha));
  const ini = sumaD(pts[0].fecha < hoy ? pts[0].fecha : hoy, -7), fin = sumaD(pts[pts.length - 1].fecha > hoy ? pts[pts.length - 1].fecha : hoy, 31);
  const t0 = new Date(`${ini}T00:00:00`).getTime(), t1 = new Date(`${fin}T00:00:00`).getTime();
  const x = (iso) => 24 + ((new Date(`${iso}T00:00:00`).getTime() - t0) / (t1 - t0)) * (W - 48);
  const maxR = Math.sqrt(Math.max(...pts.map((p) => p.monto)));
  const meses = []; for (let m = new Date(t0); m <= new Date(t1); m = new Date(m.getFullYear(), m.getMonth() + 1, 1)) { const iso = m.toISOString().slice(0, 10); if (iso >= ini && (!meses.length || x(iso) - x(meses[meses.length - 1]) > 55)) meses.push(iso); }
  return (
    <section className="rs-panel rg-sec rg-tl" data-testid="resumen-linea-tiempo">
      <h3>Línea de tiempo de vencimientos <span>altura en escala raíz cuadrada para que se vean los montos chicos{pts.some((p) => p.semana) ? " · agrupado por semana" : ""}</span></h3>
      <div className="rg-tl-wrap">
        <svg viewBox={`0 0 ${W} ${H}`} className="rg-tl-svg" preserveAspectRatio="none" aria-label="Vencimientos en el tiempo">
          <line x1="24" x2={W - 24} y1={BASE} y2={BASE} stroke="#33402F" strokeWidth="2" />
          {meses.map((m) => <g key={m}><line x1={x(m)} x2={x(m)} y1={BASE} y2={BASE + 6} stroke="#33402F" /><text x={x(m)} y={BASE + 22} textAnchor="middle" fill="#A9B8A5" fontSize="11" fontWeight="700">{MESES[Number(m.slice(5, 7)) - 1]} {m.slice(2, 4)}</text></g>)}
          <g className="rg-hoy"><line x1={x(hoy)} x2={x(hoy)} y1={10} y2={BASE} stroke="#7DBEE6" strokeWidth="2" strokeDasharray="4 4" /><text x={x(hoy)} y={9} textAnchor="middle" fill="#7DBEE6" fontSize="11" fontWeight="800">HOY {fecha(hoy).slice(0, 5)}</text></g>
          {pts.map((p, i) => {
            const h = Math.max(10, (Math.sqrt(p.monto) / maxR) * (BASE - TOP - 14)), c = colorEstado(p.dias), px = x(p.fecha);
            return (
              <g key={p.fecha} className="rg-piru" style={{ animationDelay: `${200 + i * 70}ms`, transformOrigin: `${px}px ${BASE}px` }} onMouseEnter={() => setTip(p)} onMouseLeave={() => setTip(null)} onClick={() => setTip(tip === p ? null : p)} data-testid="resumen-tl-punto">
                <line x1={px} x2={px} y1={BASE} y2={BASE - h} stroke={c} strokeWidth="3" />
                <circle cx={px} cy={BASE - h} r="7" fill={c} stroke="#141A13" strokeWidth="2" />
                <text x={px} y={BASE - h - 12} textAnchor="middle" fill="#EEF3EC" fontSize="11" fontWeight="800">{corto(p.monto)}</text>
              </g>
            );
          })}
        </svg>
        {tip && <div className="rg-tip" style={{ left: `${(x(tip.fecha) / W) * 100}%` }} data-testid="resumen-tl-tooltip"><b>{usd(tip.monto)}</b><span>{tip.semana ? `semana del ${fecha(tip.fecha)}` : fecha(tip.fecha)} · {diasTxt(tip.dias)}</span><span>{tip.facturas || 1} factura{tip.facturas === 1 ? "" : "s"}</span></div>}
      </div>
      <div className="rg-tl-ley"><i style={{ background: "#E07A62" }} />Vencido <i style={{ background: "#D2A23A" }} />Próximos 30 días <i style={{ background: "#2E9A5E" }} />Más adelante</div>
    </section>
  );
};
